/* tslint:disable */
import {
  BulkSMS,
  TenantLease,
  UserProfile
} from '../index';

declare var Object: any;
export interface BulkSMSRecipientInterface {
  "message_id"?: string;
  "status"?: string;
  "status_description"?: string;
  "error"?: string;
  "tenant_id": number;
  "ref_id": number;
  "delivery_time"?: Date;
  "id"?: number;
  bulkSMS?: BulkSMS;
  tenantLease?: TenantLease;
  tenant?: UserProfile;
}

export class BulkSMSRecipient implements BulkSMSRecipientInterface {
  "message_id": string;
  "status": string;
  "status_description": string;
  "error": string;
  "tenant_id": number;
  "ref_id": number;
  "delivery_time": Date;
  "id": number;
  bulkSMS: BulkSMS;
  tenantLease: TenantLease;
  tenant: UserProfile;
  constructor(data?: BulkSMSRecipientInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BulkSMSRecipient`.
   */
  public static getModelName() {
    return "BulkSMSRecipient";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BulkSMSRecipient for dynamic purposes.
  **/
  public static factory(data: BulkSMSRecipientInterface): BulkSMSRecipient{
    return new BulkSMSRecipient(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BulkSMSRecipient',
      plural: 'BulkSMSRecipients',
      path: 'BulkSMSRecipients',
      idName: 'id',
      properties: {
        "message_id": {
          name: 'message_id',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "status_description": {
          name: 'status_description',
          type: 'string'
        },
        "error": {
          name: 'error',
          type: 'string'
        },
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "ref_id": {
          name: 'ref_id',
          type: 'number'
        },
        "delivery_time": {
          name: 'delivery_time',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        bulkSMS: {
          name: 'bulkSMS',
          type: 'BulkSMS',
          model: 'BulkSMS',
          relationType: 'belongsTo',
                  keyFrom: 'ref_id',
          keyTo: 'id'
        },
        tenantLease: {
          name: 'tenantLease',
          type: 'TenantLease',
          model: 'TenantLease',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        tenant: {
          name: 'tenant',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
      }
    }
  }
}
